<template>
	<div class="c-media">
		<div :class="{'flex-end-cross': limit == 1}">
			<draw-sort v-model="fileList" class="flex-wrap flex-end-cross" :disabled="limit == 1">
				<template v-slot="{list}">
					<draw-item v-for="({item, key}, i) in list" :key="key" :index="i">
						<div class="c-media-item flex-center">
							<video v-if="type == 'video'" :src="item"></video>
							<img v-else :src="item">
							<a class="flex-center" @click="remove(i)" @mousedown.stop><i class="tf tf-cross"></i></a>
						</div>
					</draw-item>
					
					<div v-show="spare" slot="append" class="c-media-item c-media-upload flex-center" @click="uploadHandle">
						<i class="tf tf-plus"></i>
					</div>
				</template>
			</draw-sort>
			<div>
				<div v-if="limit == 1 && button" class="flex">
					<c-button class="c-media-button" color="gray" hollow @click="uploadHandle">{{buttonText}}</c-button>
					<slot></slot>
				</div>
				<div v-if="imageSize" class="c-media-word">图片尺寸：{{imageSizeText}}</div>
				<div v-if="word" v-html="word" class="c-media-word"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import drawSort from '@/components/draw_sort/index.vue'
	import drawItem from '@/components/draw_sort/item.vue'
	
	export default {
		components: {
			drawSort, drawItem
		},

		props: {
			type: {
				type: String,
				default: 'image'
			},
			
			size: [Number, String],
			
			value: [String, Array],
			
			oss: Boolean,
			
			limit: {
				type: Number,
				default: 1
			},
			
			button: [Boolean, String],
			
			word: String,
			
			imageSize: String
		},

		data() {
			return {
				fileList: []
			}
		},

		computed: {
			spare() {
				return this.fileList.length < this.limit;
			},
			
			imageSizeText() {
				let size = this.imageSize.split(',');
				if (size[0] == 0) {
					return `高度${size[1]}像素，宽度任意`;
				} else if (size[1] == 0) {
					return `宽度${size[0]}像素，高度任意`;
				} else {
					return size.join('X');
				}
			},
			
			buttonText() {
				if (typeof this.button != 'string') return this.oss ? '选择文件' : '上传文件';
				return this.button;
			}
		},

		watch: {
			value() {
				this.update();
			},
			
			fileList(val) {
				this.$emit('input', this.limit == 1 ? (val[0] || '') : val);
				this.$emit('change');
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.fileList = this.value ? (typeof this.value == 'object' ? this.value : this.value.toString().split(',')) : [];
			},
			
			remove(i) {
				this.fileList.splice(i, 1);
			},
			
			uploadHandle() {
				if (this.limit > 1 && this.limit <= this.fileList.length) {
					this.$message({
						text: `最多只能上传${this.limit}张图片`
					})
					return;
				}
				let count = this.limit - this.fileList.length;
				if (this.oss) {
					this.selectMedia({
						type: this.type,
						count: count,
						size: this.imageSize,
						resolve: data => {
							this.fileList = this.fileList.concat(count == 1 ? [data] : data);
						}
					});
				} else {
					this.uploadFile({
						fileType: this.type,
						fileSize: this.size,
						multiple: count > 1,
						success: data => {
							if (!Array.isArray(data)) {
								data = [data];
							}
							if (this.limit == 1) {
								this.fileList = [data[0].filePath];
							} else {
								this.fileList = this.fileList.concat(data.splice(0, count).map(item => item.filePath));
							}
						}
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-media {
		margin-top: -15px;

		&-item {
			position: relative;
			width: 90px;
			height: 90px;
			border: 1px solid #DDDDDD;
			margin-right: 15px;
			margin-top: 15px;
			background: #fff;
			box-sizing: border-box;
			
			video {
				width: 100%;
				height: 100%;
				background: #000;
			}
			
			a {
				position: absolute;
				right: 0;
				bottom: 0;
				width: 18px;
				height: 18px;
				font-size: 12px;
				color: #fff;
				background: #FF1010;
			}
		}
		
		&-upload {
			font-size: 20px;
			color: #ccc;
			cursor: pointer;
			transition: all .3s ease;
			
			&:hover {
				border-color: #bbb;
				color: #bbb;
			}
		}
		
		&-button {
			margin-right: 10px;
		}
		
		&-word {
			margin-top: 9px;
			line-height: 20px;
			font-size: 13px;
			color: #999;
		}
	}
</style>
